module.exports = __webpack_public_path__ + "linearIcons.03e91f122aa5fd425abb.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/abassey/side-proj/emp21-new/src/fonts/linearIcons.woff2?w118d
// module id = ../../../../../src/fonts/linearIcons.woff2?w118d
// module chunks = styles